<div class="basicrow ">
    <div class="container">
        <div class="basicr-line-i">
            <div class="fulltitle f-btitle autodef">
                    <span class="icon-dash-25"></span> Paga en L&iacute;nea
            </div>
        </div>
    </div>
</div>

<div class="basicrow m-top">
    <div class="container">
        <app-billing 
        (updatescreenview)="this.updscreenview()"
        (updateInitializeData)="this.initializeData()"
        [screen]="this.screen" 
        (updatescreen)="this.screen=$event"
        (updateconfirmNum)="this.confirmNum=$event"
        (updatepaymentID)="this.paymentID=$event"
        [dataPay]="this.dataPay" 
        ></app-billing>
        <app-confirm-screen 
        (updatepaymentview)="this.updpaymentview()"
        (updatescreenview)="this.updscreenview()"
        [screen]="this.screen"
        [paytext]="this.payText"
        [dataPay]="this.dataPay" 
        [confirmNum]="this.confirmNum"
        [paymentID]="this.paymentID"
        ></app-confirm-screen>
    </div>

</div>